import {getProvisionsByProduct} from '@account/api/admin-reports';
import {useQuery} from '@tanstack/react-query';

export const useProvisionsByProduct = (
  {start, end, status, isTrial},
  options = {}
) =>
  useQuery(
    [
      'admin-reports',
      'provisions-by-product',
      start,
      end,
      status ?? '',
      isTrial ?? '',
    ],
    () => getProvisionsByProduct({start, end, status, isTrial}),
    {keepPreviousData: true, ...options}
  );
